import React from 'react'
import { Image } from 'semantic-ui-react'
import g from '../images/g.png'

export default function G() {
  return <Image src={g} style={{ float: 'right', height: '25px' }} />
}
